import React, { useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import AddIcon from '@material-ui/icons/Add';
import { makeStyles } from '@material-ui/core/styles';
import Modal from './Modal';
import ModalForm from './ModalForm';
// import * as employeeService from './employeeService';

const useStyles = makeStyles(theme => ({
  pageContent: {
    margin: theme.spacing(5),
    padding: theme.spacing(3)
  },
  searchInput: {
    width: '75%'
  },
  newButton: {
    position: 'absolute',
    right: '10px'
  }
}));

export default function InSertDataToolBar(props) {
  const classes = useStyles();
  const [openPopup, setOpenPopup] = useState(false);
  const [recordForEdit, setRecordForEdit] = useState(null);
  // const [records, setRecords] = useState(employeeService.getAllEmployees());

  // const addOrEdit = (employee, resetForm) => {
  //   props.getDataFromModal(records);
  //   if (employee.id === 0) employeeService.insertEmployee(employee);
  //   else employeeService.updateEmployee(employee);
  //   resetForm();
  //   setRecordForEdit(null);
  //   setOpenPopup(false);
  //   setRecords(employeeService.getAllEmployees());
  // };

  return (
    <>
      <Tooltip title={'종목 추가'}>
        <IconButton
          onClick={() => {
            console.log(openPopup);
            setOpenPopup(true);
            setRecordForEdit(null);
          }}
        >
          <AddIcon variant="outlined" className={classes.newButton} />
        </IconButton>
      </Tooltip>
      <Modal
        title="종목 추가하기"
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
      >
        <ModalForm
          recordForEdit={recordForEdit}
          addOrEdit={props.addOrEdit}
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        />
      </Modal>
    </>
  );
}

// export default withStyles(defaultToolbarStyles, { name: "InsertDataToolBar" })(InsertDataToolBar);
